module.exports = __webpack_public_path__ + "img/uber.f059fef2.svg";